var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperationPicking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1770_2435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.125 18.25V13.375C18.125 12.8777 18.2897 12.4008 18.5827 12.0492C18.8757 11.6975 19.2731 11.5 19.6875 11.5C20.1019 11.5 20.4994 11.6975 20.7924 12.0492C21.0854 12.4008 21.25 12.8777 21.25 13.375V21.25C21.25 22.2349 21.0884 23.2102 20.7743 24.1201C20.4602 25.0301 19.9998 25.8569 19.4195 26.5533C18.8391 27.2497 18.1501 27.8022 17.3918 28.1791C16.6335 28.556 15.8208 28.75 15 28.75C11.5469 28.75 10 26.5 7.45317 20.0594C7.24597 19.628 7.19007 19.1155 7.29775 18.6346C7.40544 18.1538 7.6679 17.744 8.02739 17.4953C8.38688 17.2467 8.81396 17.1796 9.21467 17.3088C9.61539 17.438 9.95691 17.753 10.1641 18.1844L11.875 21.7469V11.875C11.875 11.3777 12.0397 10.9008 12.3327 10.5492C12.6257 10.1975 13.0231 10 13.4375 10C13.8519 10 14.2494 10.1975 14.5424 10.5492C14.8354 10.9008 15 11.3777 15 11.875V18.25",
    stroke: "#176318",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 13.375V10.375C18.125 9.87772 17.9604 9.40081 17.6674 9.04917C17.3743 8.69754 16.9769 8.5 16.5625 8.5C16.1481 8.5 15.7507 8.69754 15.4576 9.04917C15.1646 9.40081 15 9.87772 15 10.375V11.875",
    stroke: "#176318",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1770_2435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 23,
    fill: "white",
    transform: "translate(5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationPicking);
export default __webpack_public_path__ + "static/media/OperationPicking.e84fb91d21221c33cc94971ff31af40e.svg";
export { ForwardRef as ReactComponent };